// extracted by mini-css-extract-plugin
module.exports =  {"text-align-center":"_93444fe79c--text-align-center--wS6Cz","text-align-right":"_93444fe79c--text-align-right--EMFbI"};